import { redirect } from "react-router-dom";
import { deleteService } from "../../../data/loca/services";

export async function action({ request, params }) {
    await deleteService(params.serviceId);
    const isAdminPlatformRoute = new URL(request.url).pathname.startsWith("/administration/plateformes");
    return redirect(isAdminPlatformRoute ? "/administration/plateformes" : "/services/liste");
}
